import { createAction } from '@reduxjs/toolkit';
import { promoStoreTagsSlice } from './reducer';

export const fetchPromoStoreTags = createAction('promoStoreTags/fetchPromoStoreTags');

export const { clearPromoStoreTags, setPromoStoreTags, setIsFetching } = promoStoreTagsSlice.actions;
